import { Link } from 'react-router-dom';

/**
 * Gabarit temporaire des écrans pas encore développés : rend la structure de
 * navigation vérifiable tant que les fonctionnalités n'existent pas.
 */
export function Placeholder({ titre, description, children }) {
  return (
    <main className="page">
      <section className="verre">
        <h1>{titre}</h1>
        {description && <p>{description}</p>}
        {children}
        <p>
          <Link to="/">← Accueil</Link>
        </p>
      </section>
    </main>
  );
}
